export default "__VITE_ASSET__M1W8M7w8__"